<template>
    <b-container class="mt-4" fluid>
        <b-card class="mx-3" header-class="bar-color1">
            <template v-slot:header>
                <i class="fas fa-lock mr-2"></i>{{ $t('passwordchange.title') }}
            </template>

            <h5 v-if="currentUser.force_password_reset" class="text-danger mb-3">
                <i class="fas fa-user-lock mr-2"></i>{{ $t('passwordchange.mustchangepassword') }}
            </h5>

            <form>
                <password-field
                    :vuelidate-password="$v.passwordOld"
                    :label="$t('passwordchange.oldpassword')"
                    name="old-password"
                >
                    <template v-slot:description>
                        <div>{{ $t('passwordchange.oldpassword_help') }}</div>
                    </template>

                    <template v-slot:invalid-feedback>
                        <div v-if="!$v.passwordOld.required">{{ $t('error.required') }}</div>
                        <div v-if="passwordOldServerErrors">
                            <div v-for="(serverError, index) in passwordOldServerErrors" :key="'old-password-' + index">
                                {{ serverError }}
                            </div>
                        </div>
                    </template>
                </password-field>

                <password-field
                    :vuelidate-password="$v.passwordNew"
                    :label="$t('passwordchange.newpassword')"
                    name="new-password"
                >
                    <template v-slot:description>
                        <div>{{ $t('passwordchange.newpassword_help[0]') }}</div>
                        <div>{{ $t('passwordchange.newpassword_help[1]') }}</div>
                        <div>{{ $t('passwordchange.newpassword_help[2]') }}</div>
                    </template>

                    <template v-slot:invalid-feedback>
                        <div v-if="!$v.passwordOld.required">{{ $t('error.required') }}</div>
                        <div v-if="!$v.passwordOld.minLength">{{ $t('passwordchange.error.length') }}</div>
                        <div v-if="passwordNewServerErrors">
                            <div v-for="(serverError, index) in passwordNewServerErrors" :key="'new-password-' + index">
                                {{ serverError }}
                            </div>
                        </div>
                    </template>
                </password-field>

                <password-field
                    :vuelidate-password="$v.passwordConfirm"
                    :label="$t('passwordchange.passwordconfirm')"
                    name="new-password-confirm"
                >
                    <template v-slot:description>
                        <div>{{ $t('passwordchange.passwordconfirm_help') }}</div>
                    </template>

                    <template v-slot:invalid-feedback>
                        <div v-if="!$v.passwordConfirm.required">{{ $t('error.required') }}</div>
                        <div v-if="!$v.passwordConfirm.shouldBeEqualToNew">{{ $t('passwordchange.error.shouldbeequal') }}</div>
                    </template>
                </password-field>

                <b-button variant="primary" @click="changePassword">{{ $t('passwordchange.changepassword') }}</b-button>
            </form>
        </b-card>
    </b-container>
</template>

<script>
    import {minLength, required, sameAs} from "vuelidate/lib/validators";
    import PasswordField from "@/components/fields/PasswordField";
    import api from "@/api/api";
    import {isEmpty} from "lodash";
    import {mapState} from "vuex";


    export default {
        name: "PasswordChangePage",
        components: {PasswordField},
        data() {
            return {
                passwordOld: '',
                passwordOldServerErrors: [],
                passwordNew: '',
                passwordNewServerErrors: [],
                passwordConfirm: '',
            };
        },
        computed: {
            ...mapState(['currentUser']),
        },
        methods: {
            changePassword() {
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    this.passwordOldServerErrors = [];
                    this.passwordNewServerErrors = [];
                    api.changePassword(this.passwordOld, this.passwordNew)
                        .then(() => {
                            this.$router.push({name: 'home'});
                        })
                        .catch(errors => {
                            if (errors.response.data.old_password) {
                                this.passwordOldServerErrors = errors.response.data.old_password;
                            }
                            if (errors.response.data.new_password) {
                                this.passwordNewServerErrors = errors.response.data.new_password;
                            }
                        });
                }
            }
        },
        validations: {
            passwordOld: {
                required,
                validInServer: function () {
                    return isEmpty(this.passwordOldServerErrors);
                }
            },
            passwordNew: {
                required,
                minLength: minLength(8),
                validInServer: function () {
                    return isEmpty(this.passwordNewServerErrors);
                }
            },
            passwordConfirm: {
                required,
                shouldBeEqualToNew: sameAs('passwordNew')
            },
        },
    };
</script>

